module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 384 384\"><path d=\"M0 170.667h384v42.667H0z\"/></svg>";